/* 🤖 this file was generated by svg-to-ts */
export const matIconCropSquare: {
  name: 'crop-square';
  data: string;
} = {
  name: 'crop-square',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M18 4H6c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H6V6h12v12z"/></svg>`
};
